var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 0.5C3.39543 0.5 2.5 1.39543 2.5 2.5V17.5C2.5 18.6046 3.39543 19.5 4.5 19.5H15.5C16.6046 19.5 17.5 18.6046 17.5 17.5V6.20711C17.5 5.67668 17.2893 5.16797 16.9142 4.79289L13.2071 1.08579C12.832 0.710714 12.3233 0.5 11.7929 0.5H4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.5C5.83579 6.5 5.5 6.83579 5.5 7.25C5.5 7.66421 5.83579 8 6.25 8H13.75C14.1642 8 14.5 7.66421 14.5 7.25C14.5 6.83579 14.1642 6.5 13.75 6.5H6.25Z",
    fill: "",
    className: "fillDualColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.75C5.83579 9.75 5.5 10.0858 5.5 10.5C5.5 10.9142 5.83579 11.25 6.25 11.25H13.75C14.1642 11.25 14.5 10.9142 14.5 10.5C14.5 10.0858 14.1642 9.75 13.75 9.75H6.25Z",
    fill: "",
    className: "fillDualColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13C5.83579 13 5.5 13.3358 5.5 13.75C5.5 14.1642 5.83579 14.5 6.25 14.5H10.5C10.9142 14.5 11.25 14.1642 11.25 13.75C11.25 13.3358 10.9142 13 10.5 13H6.25Z",
    fill: "",
    className: "fillDualColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDocs);
export default __webpack_public_path__ + "static/media/menuDocs.1f7de081128fe2ba8f05e2bc0647323d.svg";
export { ForwardRef as ReactComponent };